<script setup lang="ts">
import BrandLogo from '@mutiblelite/ui/BrandLogo.vue'
import { RouterLink, RouterView } from 'vue-router'

const navigation = [
  { label: '首页', to: '/' },
  { label: '功能', to: '/features' },
  { label: '下载', to: '/download' },
  { label: '购买与激活', to: '/purchase' },
  { label: '隐私', to: '/privacy' },
]
</script>

<template>
  <div class="site-shell">
    <header class="site-header">
      <RouterLink class="site-brand" to="/" aria-label="返回发多多首页">
        <BrandLogo />
      </RouterLink>
      <nav class="site-nav" aria-label="官网主导航">
        <RouterLink v-for="item in navigation" :key="item.to" :to="item.to">
          {{ item.label }}
        </RouterLink>
      </nav>
    </header>

    <main>
      <RouterView />
    </main>

    <footer class="site-footer">
      <div class="site-footer__brand">
        <BrandLogo inverse />
        <p>本地多平台素材适配工具</p>
        <p>京ICP备2026056110号 </p>
      </div>
      <div>
        <strong>产品</strong>
        <p><RouterLink to="/features">功能</RouterLink> · <RouterLink to="/download">下载</RouterLink> · <RouterLink to="/help">激活帮助</RouterLink></p>
      </div>
      <div>
        <strong>法律与安全</strong>
        <p><RouterLink to="/privacy">用户协议 · 隐私政策 · 第三方许可</RouterLink></p>
      </div>
      <p class="site-footer__distribute">Windows / macOS 仅通过自有官网分发</p>
    </footer>
  </div>
</template>
